import type { CSSProperties } from 'react'
import { colors } from 'settings/colors'
import type { TRect } from '../types'
import type { TPanelDragHandlers } from '../usePanelDrag'

export const RightPanelHandle = ({
  rect,
  transition,
  isWideScreen,
  dragHandlers,
}: {
  rect: TRect
  transition: CSSProperties['transition']
  isWideScreen: boolean
  dragHandlers: TPanelDragHandlers
}) => (
  <>
    <div
      css={{
        position: 'fixed',
        borderTopLeftRadius: 10,
        borderBottomLeftRadius: 10,
        cursor: isWideScreen ? 'ew-resize' : 'default',
        backgroundColor: colors.midnight,
        display: 'flex',
        zIndex: 0,
        alignItems: 'center',
      }}
      style={{ ...rect, transition }}
      {...dragHandlers}
    >
      {isWideScreen && (
        <div
          css={{ width: 5, height: 47, backgroundColor: colors.grey200, borderRadius: 10, marginLeft: 10 }}
        />
      )}
    </div>
    {!isWideScreen && (
      <div
        css={{
          position: 'fixed',
          bottom: 'calc(5px + env(safe-area-inset-bottom))',
          height: 38,
          zIndex: 0,
          borderBottomLeftRadius: 10,
          background: `linear-gradient(0deg, ${colors.grey800} 5%, ${colors.midnight} 95%)`,
        }}
        style={{ left: rect.left, width: rect.width, transition }}
      />
    )}
  </>
)
